import { render, staticRenderFns } from "./ScoreCardItem.vue?vue&type=template&id=62cd376a&scoped=true&"
import script from "./ScoreCardItem.vue?vue&type=script&lang=js&"
export * from "./ScoreCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardItem.vue?vue&type=style&index=0&id=62cd376a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd376a",
  null
  
)

export default component.exports